import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const DinningAreaIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "DinningAreaIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M7.58787 12.0014H5.63694V7.55333C5.63591 6.73488 4.97268 6.07165 4.15423 6.07062H2.90563C2.60394 6.07062 2.35938 6.31519 2.35938 6.61688V19.1028C2.35938 19.4045 2.60394 19.6491 2.90563 19.6491C3.20732 19.6491 3.45189 19.4045 3.45189 19.1028V15.279H7.97806V19.1028C7.97806 19.4045 8.22263 19.6491 8.52432 19.6491C8.82601 19.6491 9.07058 19.4045 9.07058 19.1028V13.4842C9.06955 12.6657 8.40632 12.0025 7.58787 12.0014ZM3.45189 7.16314H4.15423C4.36958 7.16348 4.54408 7.33797 4.54443 7.55333V12.5477C4.54443 12.8494 4.78899 13.094 5.09068 13.094H7.58787C7.80323 13.0943 7.97772 13.2688 7.97807 13.4842V14.1865H3.45189V7.16314Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.6347 6.07062H20.3861C19.5676 6.07165 18.9044 6.73488 18.9034 7.55333V12.0014H16.9524C16.134 12.0025 15.4708 12.6657 15.4697 13.4842V19.1028C15.4697 19.4045 15.7143 19.6491 16.016 19.6491C16.3177 19.6491 16.5622 19.4045 16.5622 19.1028V15.279H21.0884V19.1028C21.0884 19.4045 21.333 19.6491 21.6347 19.6491C21.9364 19.6491 22.1809 19.4045 22.1809 19.1028V6.61688C22.1809 6.31519 21.9364 6.07062 21.6347 6.07062ZM16.5623 13.4842C16.5626 13.2688 16.7371 13.0943 16.9524 13.094H19.4496C19.7513 13.094 19.9959 12.8494 19.9959 12.5477V7.55333C19.9962 7.33798 20.1707 7.16349 20.3861 7.16314H21.0884V14.1865H16.5623L16.5623 13.4842Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.9522 10.9084C17.2539 10.9084 17.4985 10.6638 17.4985 10.3621C17.4985 10.0604 17.2539 9.81585 16.9522 9.81585H16.562V7.86492C16.562 7.56323 16.3175 7.31866 16.0158 7.31866H13.8307C13.5291 7.31866 13.2845 7.56323 13.2845 7.86492V9.81585H11.2555V7.86492C11.2555 7.56323 11.0109 7.31866 10.7093 7.31866H8.52421C8.22252 7.31866 7.97795 7.56323 7.97795 7.86492V9.81585H7.58776C7.28607 9.81585 7.0415 10.0604 7.0415 10.3621C7.0415 10.6638 7.28607 10.9084 7.58776 10.9084H11.7237V18.556H11.3335C11.0319 18.556 10.7873 18.8006 10.7873 19.1023C10.7873 19.404 11.0319 19.6485 11.3335 19.6485H13.2064C13.5081 19.6485 13.7527 19.404 13.7527 19.1023C13.7527 18.8006 13.5081 18.556 13.2064 18.556H12.8162V10.9084H16.9522ZM14.377 8.41118H15.4695V9.81585H14.377V8.41118ZM9.07047 8.41118H10.163V9.81585H9.07047V8.41118Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default DinningAreaIcon;
